import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';
import { ProductIconWasser } from './ProductIconWasser';
import { ProductIconStrom } from './ProductIconStrom';
import { ProductIconGas } from './ProductIconGas';
import { ProductIconStromEco } from './ProductIconStromEco';
import { ProductIconTranchenmodellEco } from './ProductIconTranchenmodellEco';
import { ProductIconTranchenmodellErdgas } from './ProductIconTranchenmodellErdgas';
import { ProductIconTranchenmodellStrom } from './ProductIconTranchenmodellStrom';
import { ProductIconTankdemontageErdgas } from './ProductIconTankdemontageErdgas';
import { ProductIconEMobility } from './ProductIconEMobility';
import { ProductIconEnergieAudit } from './ProductIconEnergieAudit';
import { ProductIconEchteWaerme } from './ProductIconEchteWaerme';
import { ProductIconDigitaleWohnungsuebergabe } from './ProductIconDigitaleWohnungsuebergabe';
import { ProductIconPhone } from './ProductIconPhone';

export enum ProductItemType {
  WASSER,
  STROM,
  ERDGAS,
  STROM_ECO,
  TRANCHENMODELL_STROM,
  TRANCHENMODELL_ERDGAS,
  TRANCHENMODELL_ECO,
  TANKDEMONTAGE_ERDGAS,
  EMOBILITY,
  ENERGIE_AUDIT,
  ECHTE_WAERME,
  DIGITALE_WOHNUNGSUEBERGABE,
  PHONE,
}

export const PRODUCT_ITEM_TYPES = [
  'WASSER',
  'STROM',
  'ERDGAS',
  'STROM_ECO',
  'TRANCHENMODELL_STROM',
  'TRANCHENMODELL_ERDGAS',
  'TRANCHENMODELL_ECO',
  'TANKDEMONTAGE_ERDGAS',
  'EMOBILITY',
  'ENERGIE_AUDIT',
  'ECHTE_WAERME',
  'DIGITALE_WOHNUNGSUEBERGABE',
  'PHONE',
]

export const parseProductItemType = (identifier: string) => {
  switch (identifier || 'WASSER') {
    case 'STROM': return ProductItemType.STROM;
    case 'ERDGAS': return ProductItemType.ERDGAS;
    case 'STROM_ECO': return ProductItemType.STROM_ECO;
    case 'TRANCHENMODELL_STROM': return ProductItemType.TRANCHENMODELL_STROM;
    case 'TRANCHENMODELL_ERDGAS': return ProductItemType.TRANCHENMODELL_ERDGAS;
    case 'TRANCHENMODELL_ECO': return ProductItemType.TRANCHENMODELL_ECO;
    case 'TANKDEMONTAGE_ERDGAS': return ProductItemType.TANKDEMONTAGE_ERDGAS;
    case 'EMOBILITY': return ProductItemType.EMOBILITY;
    case 'ENERGIE_AUDIT': return ProductItemType.ENERGIE_AUDIT;
    case 'ECHTE_WAERME': return ProductItemType.ECHTE_WAERME;
    case 'DIGITALE_WOHNUNGSUEBERGABE': return ProductItemType.DIGITALE_WOHNUNGSUEBERGABE;
    case 'PHONE': return ProductItemType.PHONE;
    case 'WASSER':
    default:
      return ProductItemType.WASSER;
  }
}

export const parseProductColorSet = (colorSet?: string) => {
  switch (colorSet || 'WHITE') {
    case 'BLUE': return '#3B69B0';
    case 'GREEN': return '#657F32';
    case 'ORANGE': return Colors.tertiary;
    case 'RED': return '#BB0617';
    default: return Colors.white;
  }
}
export const parseProductColorSetIcon = (colorSet?: string) => {
  switch (colorSet || 'WHITE') {
    case 'BLUE': return '#83D0F5';
    case 'GREEN': return Colors.secondary;
    case 'ORANGE': return Colors.tertiary;
    case 'RED': return '#BE4347';
    default: return Colors.white;
  }
}
export const parseProductColorSetGradient = (colorSet?: string) => {
  switch (colorSet || 'WHITE') {
    case 'BLUE':
      return `linear-gradient(to top right, ${Colors.primaryLight}, #587D96)`;
    case 'GREEN':
      return `linear-gradient(to top right, ${Colors.secondary}, #657F32)`;
    case 'ORANGE':
      return `linear-gradient(to top right, #F39238, #935C00)`;
    case 'RED':
      return `linear-gradient(to top right, #BB0617, #82181C)`;
    default:
      return `linear-gradient(to top right, #B0B0AE, ${Colors.grayDark})`;
  }
}

interface Props {
  type: ProductItemType;
  color: string;
}
export const ProductIconWrapper: FC<Props> = ({ type = ProductItemType.WASSER, color = Colors.white }) => {
  switch (type) {
    case ProductItemType.STROM: return <ProductIconStrom color={color} />;
    case ProductItemType.ERDGAS: return <ProductIconGas color={color} />;
    case ProductItemType.STROM_ECO: return <ProductIconStromEco color={color} />;
    case ProductItemType.TRANCHENMODELL_STROM: return <ProductIconTranchenmodellStrom color={color} />;
    case ProductItemType.TRANCHENMODELL_ERDGAS: return <ProductIconTranchenmodellErdgas color={color} />;
    case ProductItemType.TRANCHENMODELL_ECO: return <ProductIconTranchenmodellEco color={color} />;
    case ProductItemType.TANKDEMONTAGE_ERDGAS: return <ProductIconTankdemontageErdgas color={color} />;
    case ProductItemType.EMOBILITY: return <ProductIconEMobility color={color} />;
    case ProductItemType.ENERGIE_AUDIT: return <ProductIconEnergieAudit color={color} />;
    case ProductItemType.ECHTE_WAERME: return <ProductIconEchteWaerme color={color} />;
    case ProductItemType.DIGITALE_WOHNUNGSUEBERGABE: return <ProductIconDigitaleWohnungsuebergabe color={color} />;
    case ProductItemType.PHONE: return <ProductIconPhone color={color} />;
    case ProductItemType.WASSER:
    default: return <ProductIconWasser color={color} />;
  }
}
